import api from '.';
import { PipingPlantType } from '../pages/MasterData/PipingPlantType/pipingPlantTypeSlice';

interface ReturnTypePipingPlantType {
  data: PipingPlantType[];
}

export async function getPipingPlantTypes(): Promise<ReturnTypePipingPlantType> {
  const { data } = await api.get('/piping-plant-types');

  return data;
}
